import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "materials-card" };
var _hoisted_2 = { class: "materials-card__title" };
var _hoisted_3 = { class: "materials-card__subtitle" };
import ArrowToRightIcon from '@/icons/ArrowToRightIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MaterialLinkCard',
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: false
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createBlock(_component_router_link, {
                to: __props.link ? __props.link : '/'
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, [
                            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.subtitle), 1)
                        ]),
                        _createVNode(_component_el_icon, { size: 24 }, {
                            default: _withCtx(function () { return [
                                _createVNode(ArrowToRightIcon, { color: '#222222' })
                            ]; }),
                            _: 1
                        })
                    ])
                ]; }),
                _: 1
            }, 8, ["to"]));
        };
    }
});
